import { Snackbar, SnackbarProps } from '@material-ui/core';
import { Theme, css } from '@emotion/react';
import React from 'react';

interface ToastProps extends SnackbarProps {
  slimRight?: boolean;
}

// 08-07-24 Possible TODO: now that the redux store supports multiple toasts, this could be reworked
// to better support displaying multiple toast simultanousely. The MUI snackbar is intended for
// one-at-a-time use (though it works now, they just stack on top of each other). Not an issue
// at the moment since we don't have anywhere in consumer where we attempt to display multiple
// toasts. But it would only take a small bit of reworking to display them nicely.
const Toast: React.FunctionComponent<ToastProps> = ({ slimRight, ...props }) => {
  return (
    <Snackbar
      css={({ shadow, breakpoints, spacing }: Theme) => css`
        &.MuiSnackbar-root {
          box-shadow: ${shadow[100]};
        }

        & > .MuiPaper-root.MuiAlert-root {
          width: 100%;
          min-height: 44px;
          padding: ${spacing(1)}px ${spacing(slimRight ? 1.5 : 2.5)}px;

          ${breakpoints.up('sm')} {
            width: 430px; // Width for desktop messages
          }
        }
      `}
      {...props}
    />
  );
};

export default Toast;
